module.exports = __webpack_public_path__ + "img/card3hover.ee1daac3.svg";